import { CHECKOUT_ITEM_TYPE_TOUR_V2 } from 'constants/checkout'

export function itemsAreTourV2(
  items: Array<App.Checkout.AccommodationItem>,
): items is Array<App.Checkout.TourV2Item> {
  return items[0].itemType === CHECKOUT_ITEM_TYPE_TOUR_V2
}
